import { useEventCallback } from '@mui/material/utils';

import { useDialogs } from '@work4all/components';

import { ProjectTimeMaskInit } from '../../../containers/time-tracker/ProjectTimeMask';
import { TimeTrackingMask } from '../mask';

type OpenMaskFunctionProps =
  | { mode: 'create'; initialData?: ProjectTimeMaskInit }
  | { mode: 'edit'; id: number }
  | { mode: 'clone'; id: number };

export const useOpenTimeTrackingMask = () => {
  const dialogs = useDialogs();

  return useEventCallback((props: OpenMaskFunctionProps) => {
    const dialog = dialogs.open(TimeTrackingMask, {
      ...props,
      close,
    });

    function close() {
      dialogs.close(dialog.id);
    }
  });
};
